/*
 * Hero Image Molecule Component
 *
 */

import React, { useState } from "react"
import PropTypes from "prop-types"
import Button from "../../atoms/button/button"

const HeroImage = props => {
  const [creditsOpen, setCreditsOpen] = useState(false)

  const openCredits = () => {
    setCreditsOpen(!creditsOpen)
  }

  return (
    <>
      <div className="hero-image">
        <div className="hero-image__image-placeholder">
          <img
            className="hero-image__image"
            src={`${props.imageFilename}${
              props.isStorybook ? "" : "/m/1600x900"
            }`}
            alt={props.imageALT}
          />
          <ul className="hero-image__badges">
            {props.resourceType ? (
              <li>
                <div className="hero-image__badge">{props.resourceType}</div>
              </li>
            ) : (
              <>
                {props.categoryType ? (
                  <li>
                    <div className="hero-image__badge">
                      {props.categoryType}
                    </div>
                  </li>
                ) : (
                  <></>
                )}

                {props.categoryLocation ? (
                  <li>
                    <div className="hero-image__badge">
                      {props.categoryLocation}
                    </div>
                  </li>
                ) : (
                  <></>
                )}

                {props.categoryFocus ? (
                  <li>
                    <div className="hero-image__badge">
                      {props.categoryFocus}
                    </div>
                  </li>
                ) : (
                  <></>
                )}
              </>
            )}
          </ul>

          <div className="hero-image__footer">
            {props.collaborationBadge ? (
              <div className="hero-image__badge">
                <div className="hero-image__collaboration-badge-on"></div>
                <span>seeking collaboration</span>
              </div>
            ) : (
              <></>
            )}
            <div
              className={`hero-image__imageCredits ${
                creditsOpen ? "hero-image__imageCredits--open" : ""
              }`}
            >
              <p>
                <small>© copyright: {props.imageCopyright}</small>
                {props.imageSource ? (
                  <small>source: {props.imageSource}</small>
                ) : (
                  <></>
                )}
              </p>
            </div>
          </div>
          <Button
            className={`hero-image__credits-button ${
              creditsOpen ? "hero-image__credits-button--active" : ""
            }`}
            icon="copyright"
            iconTitle="view image rights"
            srOnly="view image rights"
            onClick={openCredits}
            modifier="--credits-button"
            text=""
          />
        </div>
      </div>
    </>
  )
}

HeroImage.defaultProps = {
  imageFilename: "",
  imageCopyright: "",
  imageSource: "",
  imageALT: "",
  resourceType: "",
  categoryType: "",
  categoryLocation: "",
  categoryFocus: "",
  collaborationBadge: false,
  isStorybook: false,
}

HeroImage.propTypes = {
  imageFilename: PropTypes.string.isRequired,
  imageCopyright: PropTypes.string,
  imageSource: PropTypes.string,
  imageALT: PropTypes.string.isRequired,
  resourceType: PropTypes.string,
  categoryType: PropTypes.string,
  categoryLocation: PropTypes.string,
  categoryFocus: PropTypes.string,
  collaborationBadge: PropTypes.bool,
  isStorybook: PropTypes.bool,
}

export default HeroImage
